import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

const VideoLength = ({
  trialDetails,
  setTrialDetails,
  handleBasicInfoUpdate,
  videoLength,
  setVideoLength,
}) => {
  const user_data = JSON.parse(localStorage.getItem("user_data"));
  const role = user_data.role;
  const [isValueUpdated, setIsValueUpdated] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setTrialDetails((prevDetails) => ({
      ...prevDetails,
      video_length: value,
    }));
    setVideoLength(true);
    setIsValueUpdated(true);
  };

  const handleSave = () => {
    handleBasicInfoUpdate();
    setIsValueUpdated(false);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 2,
        }}
      >
        <TextField
          label="Video Length"
          size="small"
          type="number"
          name="video_length"
          value={trialDetails.video_length || ""}
          onChange={handleChange}
          sx={{ width: { xs: "100%", md: "50%" } }}
        />

        {role !== "Investigator" && role !== "Inv_coordinator" && role !== "Reviewer" && (
          <Button
            variant="contained"
            size="small"
            id="video-length-settings"
            onClick={handleSave}
            disabled={!videoLength || !isValueUpdated}
          >
            Save
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default VideoLength;
